export default __webpack_public_path__ + "static/media/crm.28c50f13.svg";